<template>
  <MessageLayout :is-archived="isArchived" :message="message">
    <h6 slot="header" class="message__title">
      Votre ticket du {{ message.date_for_display }} est
      <span :style="{ color: paletteFidmarques.green }">
        à valider
      </span>
    </h6>

    <div slot="content" class="message__body">
      <div
        v-if="!hasBenefits && !hasOtherBrandsBenefits"
        class="section section--inverse section--empty"
      >
        Le robot n’a rien détecté sur votre ticket
      </div>

      <div
        v-if="hasBenefits"
        class="section"
        :class="{ 'section--inverse': !hasOtherBrandsBenefits }"
      >
        <h6 v-if="hasOtherBrandsBenefits" class="section__title">
          Bénéfices {{ programName }}
        </h6>
        <MessageBenefitsSummary
          :points-count="message.data.earned_points_count"
          :collector-pieces-count="message.data.earned_collector_pieces_count"
          :coupons-count="message.data.used_coupons_count"
          :pot-increment="message.data.pot_increment"
        />
      </div>

      <div v-if="hasOtherBrandsBenefits" class="section">
        <h6 class="section__title">
          Bénéfices d'autres marques
        </h6>
        <MessageBenefitsSummary
          :points-count="message.data.other_brands_earned_points_count"
          :collector-pieces-count="message.data.other_brands_earned_collector_pieces_count"
          :coupons-count="message.data.other_brands_used_coupons_count"
          :pot-increment="message.data.other_brands_pot_increment"
        />
      </div>
    </div>

    <ul slot="footer" class="message__actions">
      <li v-for="action in message.actions" :key="action.title" class="message__action">
        <ButtonV3
          class="message__button"
          :text="action.title"
          text-size="12px"
          full-width
          color="white"
          :bg-color="action.button_color"
          :border-color="action.button_color"
          @click="interpreteSchemeUrl(action.scheme_url)"
        />
      </li>
    </ul>
  </MessageLayout>
</template>

<script>
import { mapState } from 'vuex'

import Mixin from './mixin'

import MessageBenefitsSummary from '../MessageBenefitsSummary'

import ButtonV3 from '../../../elements/ButtonV3'

export default {
  components: {
    MessageBenefitsSummary,
    ButtonV3,
  },
  mixins: [Mixin],
  props: {
    message: {
      type: Object,
      required: true,
      validator: message =>
        message.hasOwnProperty('data') &&
        message.data.hasOwnProperty('earned_points_count') &&
        message.data.hasOwnProperty('earned_collector_pieces_count') &&
        message.data.hasOwnProperty('used_coupons_count') &&
        message.data.hasOwnProperty('pot_increment') &&
        message.data.hasOwnProperty('other_brands_earned_points_count') &&
        message.data.hasOwnProperty('other_brands_earned_collector_pieces_count') &&
        message.data.hasOwnProperty('other_brands_used_coupons_count') &&
        message.data.hasOwnProperty('other_brands_pot_increment') &&
        true
      ,
    },
  },
  computed: {
    ...mapState('server', ['programName']),

    hasBenefits () {
      return (
        this.message.data.earned_points_count !== 0 ||
        this.message.data.earned_collector_pieces_count !== 0 ||
        this.message.data.used_coupons_count !== 0 ||
        this.message.data.pot_increment !== 0 ||
        false
      )
    },
    hasOtherBrandsBenefits () {
      return (
        this.message.data.other_brands_earned_points_count !== 0 ||
        this.message.data.other_brands_earned_collector_pieces_count !== 0 ||
        this.message.data.other_brands_used_coupons_count !== 0 ||
        this.message.data.other_brands_pot_increment !== 0 ||
        false
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/mixins";
@import "~assets/css/variables";

.section--empty {
  text-align: center;
  padding: 1.5rem 1rem;
}
.section--inverse {
  background-color: $color-border-gray-ul;
}

.section:last-child {
  border-bottom: 1px solid $color-border-gray-disabled;
}
.section--inverse:last-child {
  border-bottom: none;
}

.message__title {
  @include font-family__oswald;
  padding: 0;
  margin: 0;
}

.message__body {
  padding: 0;
  margin: 0;
}

.section__title {
  background-color: $color-border-gray-ul;
  padding: 0.5rem 1rem;
  margin: 0;
}

.message__actions {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}
.message__action {
  flex: 1;
}
.message__action + .message__action {
  margin-left: 1rem;
}
</style>
